import React from 'react'
import failureIcon from '../../assets/images/unsuccessful.png';

function PaymentFailure() {
  return (
      <div className="Payment__Card">
          <div>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <img src={failureIcon} />
              </div>
              <p className="mt-3 mb-0" style={{ color: '#e00101', fontSize: '18px', fontWeight: '600', textAlign:'center' }}>
                  Sorry
              </p>
              <p className="mt-1" style={{ color: '#e00101', fontSize: '18px', fontWeight: '600' }}>
                  Payment Failed
              </p>
          </div>
      </div>
  );
}

export default PaymentFailure